import gql from 'graphql-tag';
export const ProductCustomizationOptionDetailFragment = gql`
    fragment ProductCustomizationOptionDetail on ProductCustomizationOption {
      id
      createdAt
      updatedAt
      name
      code
      enabled
      type
      content
      channels {
        id
        code
      }
      previewAsset {
        id
        name
        preview
        focalPoint {
          x
          y
        }
      }
    }
`;

export const GetAllProductCustomizationOptionListDocument = gql`
  query GetProductCustomizationOptionList($options: ProductCustomizationOptionListOptions) {
    productCustomizationOptions(options: $options) {
      items {
        id
        createdAt
        updatedAt
        name
        code
        enabled
        type
        previewAsset {
            id
            name
            preview
            focalPoint {
                x
                y
            }
        }
        channels {
          id
          code
        }
      }
      totalItems
    }
  }
`;

export const ASSIGN_PRODUCT_CUSTOMIZATION_OPTION_TO_CHANNELS = gql`
  mutation AssignProductCustomizationOption($id: ID!, $channelIds: [ID!]!) {
    assignProductCustomizationOptionToChannels(id: $id, channelIds: $channelIds) {
      id
      channels {
        id
        code
      }
    }
  }
`;

export const REMOVE_PRODUCT_CUSTOMIZATION_OPTION_FROM_CHANNELS = gql`
  mutation RemoveProductCustomizationOption($id: ID!, $channelIds: [ID!]!) {
    removeProductCustomizationOptionFromChannels(id: $id, channelIds: $channelIds) {
      id
      channels {
        id
        code
      }
    }
  }
`;

export const getProductCustomizationOptionDocument = gql`
  query GetProductCustomizationOption($id: ID!) {
    productCustomizationOption(id: $id) {
      ...ProductCustomizationOptionDetail
    }
  }
  ${ProductCustomizationOptionDetailFragment}
`;

export const createProductCustomizationOptionDocument = gql`
  mutation createProductCustomizationOption($input: CreateProductCustomizationOptionInput!) {
    createProductCustomizationOption(input: $input) {
      ...ProductCustomizationOptionDetail
    }
  }
  ${ProductCustomizationOptionDetailFragment}
`;

export const updateProductCustomizationOptionDocument = gql`
  mutation updateProductCustomizationOption($input: UpdateProductCustomizationOptionInput!) {
    updateProductCustomizationOption(input: $input) {
      ...ProductCustomizationOptionDetail
    }
  }
  ${ProductCustomizationOptionDetailFragment}
`;

export const DELETE_PRODUCT_CUSTOMIZATION_OPTION = gql`
  mutation DeleteProductCustomizationOption($input: DeleteProductCustomizationOptionInput!) {
    deleteProductCustomizationOption(input: $input) {
      result
      message
    }
  }
`;

export const EXPORT_PRODUCT_CUSTOMIZATION_OPTION = gql`
  mutation ExportProductCustomizationOption($id: ID!) {
    exportProductCustomizationOption(id: $id)
  }
`;

export const IMPORT_PRODUCT_CUSTOMIZATION_OPTION = gql`
    mutation ImportProductCustomizationOption($input: String!) {
        importProductCustomizationOption(input: $input) {
            id
            name
            code
            type
        }
    }
`;

export const GET_ORDERLINE_CUSTOMIZATION_OPTION_NAME = gql`
    query GetOrderLineCustomizationOptionName($orderLineId: ID!) {
        getOrderLineCustomizationOptionName(orderLineId: $orderLineId)
    }
`;

export const GET_ORDERLINE_ORDERED_ASSET_IDS = gql`
    query GetOrderLineOrderedAssetIds($orderLineId: ID!) {
        getOrderLineOrderedAssetIds(orderLineId: $orderLineId)
    }
`;


export const GET_CUSTOMIZABLE_ASSETS_BUNDLE_URL = gql`
    query GetCustomizableAssetsBundleUrl($orderLineId: ID!) {
        getCustomizableAssetsBundleUrl(orderLineId: $orderLineId) {
            url
            status
        }
    }
`;

export const REGENERATE_CUSTOMIZABLE_ASSET_BUNDLE = gql`
    mutation RegenerateCustomizableAssetBundle($orderLineId: ID!) {
        regenerateCustomizableAssetBundle(orderLineId: $orderLineId)
    }
`;

export const CREATE_CUSTOMIZABLE_IMAGE_DOWNLOAD_URLS = gql`
    mutation CreateCustomizableImageDownloadUrls($input: CreateCustomizableImageDownloadUrlsInput!) {
        createCustomizableImageDownloadUrls(input: $input) {
            imageDownloadUrl
            thumbnailImageDownloadUrl
        }
    }
`;

export const BULK_EXPORT_PRODUCT_CUSTOMIZATION_OPTIONS = gql`
  mutation BulkExportProductCustomizationOptions($ids: [ID!]) {
    bulkExportProductCustomizationOptions(ids: $ids)
  }
`;

export const BULK_IMPORT_PRODUCT_CUSTOMIZATION_OPTIONS = gql`
  mutation BulkImportProductCustomizationOptions($input: String!) {
    bulkImportProductCustomizationOptions(input: $input) {
      created { id name code }
      updated { id name code }
      errors { code message }
    }
  }
`;

export const GET_PRODUCT_CUSTOMIZATION_OPTION_IDS_BY_PRODUCT = gql`
    query GetProductCustomizationOptionIdsByProduct($id: ID!) {
        product(id: $id) {
            id
            customFields {
                customizationOptions
            }
        }
    }
`;

export const GET_PRODUCT_CUSTOMIZATION_OPTIONS = gql`
    query GetProductCustomizationOptions($term: String, $type: String) {
        productCustomizationOptions(
            options: {
                filter: {
                    type: { eq: $type }
                    name: { contains: $term }
                }
                take: 50
            }
        ) {
            items {
                id
                name
                type
                previewAsset {
                    # custom field or relation on your entity
                    preview
                }
            }
        }
    }
`;
